export function getPos(scroll, el, mouseX, mouseY){
    // yay readability
    const scrollLeft = scroll.scrollLeft;
    const scrollTop = scroll.scrollTop;
    for (var lx=0, ly=0;
         el != null;
         lx += el.offsetLeft, ly += el.offsetTop, el = el.offsetParent);
    return {x: mouseX-lx+scrollLeft,y: mouseY-ly+scrollTop};
}